(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    (() => {
    const tracked = new WeakSet();

    function attachBadges() {
      document.querySelectorAll('.ssc-artwork-badge').forEach((badge) => {
        if (tracked.has(badge)) return;

        const container = badge.parentElement;
        const img = container.querySelector('.product-media__image');
        if (!img) return;
        tracked.add(badge);

        const position = () => {
          const imageBox = img.getBoundingClientRect();
          const parentBox = container.getBoundingClientRect();

          if (!img.naturalWidth || !imageBox.width || !imageBox.height) {
            badge.style.visibility = 'hidden';
            return;
          }

          const style = getComputedStyle(img);
          let width = imageBox.width;
          let height = imageBox.height;

          if (style.objectFit === 'contain' || style.objectFit === 'scale-down') {
            let scale = Math.min(
              width / img.naturalWidth,
              height / img.naturalHeight
            );

            if (style.objectFit === 'scale-down') {
              scale = Math.min(1, scale);
            }

            width = img.naturalWidth * scale;
            height = img.naturalHeight * scale;
          }

          const offsets = style.objectPosition.split(' ');
          const fraction = (value) =>
            value?.endsWith('%') ? parseFloat(value) / 100 : 0.5;

          const left = imageBox.left - parentBox.left +
            (imageBox.width - width) * fraction(offsets[0]);

          const top = imageBox.top - parentBox.top +
            (imageBox.height - height) * fraction(offsets[1]);

          badge.style.setProperty('--ssc-badge-left', `${left + 12}px`);
          const badgeTop = container.closest('.card-gallery')
  ? top + height - badge.offsetHeight - 12
  : top + 12;

badge.style.setProperty('--ssc-badge-top', `${badgeTop}px`);
          badge.style.setProperty(
            '--ssc-badge-width',
            `${Math.max(0, width - 24)}px`
          );

          badge.style.visibility = 'visible';
        };

        const observer = new ResizeObserver(position);
        observer.observe(container);
        observer.observe(img);
        img.addEventListener('load', position);
        position();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachBadges, {
        once: true
      });
    } else {
      attachBadges();
    }

    new MutationObserver(attachBadges).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
